let loadPromise: Promise<void> | null = null;

export function loadNhsSdk(envBaseUrl: string, cacheBust?: string): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve(); // SSR safety
  if (windowHasNhsSdk()) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    const v = cacheBust ? `?v=${encodeURIComponent(cacheBust)}` : '';
    script.src = `${envBaseUrl.replace(/\/$/, '')}/js/v2/nhsapp.js${v}`;
    script.async = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load NHS App JS API: ${script.src}`));

    document.head.appendChild(script);
  });

  return loadPromise;
}

export function windowHasNhsSdk(): boolean {
  return typeof window !== 'undefined' && typeof (window as any).nhsapp !== 'undefined';
}
